class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    validateMaxfreeSample();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
           validateMaxfreeSample();
          ClearCartDrawerNew();
            enableSlider();
           AddFreeGift();
   $.getJSON('/cart.js', function(cart) {
            var var_id = '';
            var spent = 0;
            $('.mini-cart__main .mini-cart-items').each(function(){
               var pro_id = $(this).attr('data-variant-id');
               var enable = $(this).attr('data-combo-spend-freep');
               var amount = $(this).attr('data-combo-invest');
               if(enable=="true"){
                  var_id = pro_id;
                  spent = amount*100 ;
               }
            });
          if(parseFloat(cart.total_price) < parseFloat(spent)){
             $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                async: true,
                data:{
                  id: var_id,
                  quantity: 0
                },
                dataType: 'json',
                success: function(){
                  updateCart();
                  // window.location.assign('/cart');
                },
                error: function(error){
                  console.log(error);   
                },
              });
              return false;
           }
          if( cart.total_price <= 0){
           $(".checkout-btn").prop("disabled", true);
             setTimeout(function (){
               $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                data: '',
                dataType: 'json',
                success: function() {
                $(".mini-cart__empty").show();
                $(".mini-cart__footer").hide();
                updateCart();
                },
                error: function(XMLHttpRequest, textStatus) {
                  console.log('error');
                }
              });
            return false;
           },100);
         }
           
        });
        
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);



function ClearCartDrawerNew(){
  $.getJSON('/cart.js', function(cart) {
    console.log(cart.total_price)
             if( cart.total_price <= 0){
             $(".checkout-btn").prop("disabled", true);
               $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                data: '',
                dataType: 'json',
                success: function() {
                $(".mini-cart__empty").show();
                $(".mini-cart__footer").hide();
                $('.mini-cart').addClass('is-empty');
                   updateCart();
                  
                   console.log("pause......here");
                },
                error: function(XMLHttpRequest, textStatus) {
                  updateCart();
                  console.log('error');
                  
                }
              });
            return false;
             }
  })
}

function enableSlider() {
  if($("#freesample-mini-cart").length > 0){
    var interval = setInterval(function() {
        if ($('#freesample-mini-cart').hasClass('flickity-enabled')) {
            $("#freesample-mini-cart").flickity('destroy');
            clearInterval(interval);
        } else {
            var flkty = new Flickity("#freesample-mini-cart", {
                wrapAround: true,
                pageDots: false,
                initialIndex: 1,
                accessibility: true,
                autoPlay: false,
              groupcells:2
            });
            clearInterval(interval);
            var divCount = $(".flickity-slider .total-modalninfo").length;
              if (divCount < 2) {
                $(".free-sample-products").addClass("arrow-disabled");
              }else {
                $(".free-sample-products").removeClass("arrow-disabled");
              }
        }
    });
  }
}


 function validateMaxfreeSample(){
   var maxValueFree = $(".free-sample-gift-container").attr("max-free-sample")
     // setTimeout(function(){
       jQuery.getJSON('/cart.js', function(cart) {
          var items = cart.items;
          var carttotal = carttotal;
          var atc_flag = 0
          for(var i=0; i < items.length; i++ ){
             var item_handle = items[i].id;
             var properties = items[i].properties;
             if(items[i].properties != undefined && items[i].properties != '' && items[i].properties != null) {
             if(items[i].properties._free_sample_product == "free_sample_product" ){
               var atc_flag = parseInt(atc_flag+1)
               $('.add-free-sample-btn').css('display', 'block');
               $(".prdtClssAdd--"+item_handle).hide();
               $(".prdtClssRmv--"+item_handle).show();
             }
           }
        }   
         if( maxValueFree != atc_flag){
             $('.add-free-sample-btn').css('display', 'block');
           }
       if( maxValueFree <= atc_flag){
         $(".free-sample-atc-jtpl").prop("disabled", true)
       }
        });
          if($(".product-content .product-title").length > 0){
            $(".product-content .product-title").each(function(){ 
              var $this =$(this); var text =  $(this).text();
              
              if(text.indexOf("Stay All Day®") > -1){ 
              var new_text = text.replace("Stay All Day®","<strong>Stay All Day®</strong>"); 
              $this.html(new_text); 
              }
               if(text.indexOf("Correct & Perfect") > -1){ 
               var new_text = text.replace("Correct & Perfect","<strong>Correct & Perfect</strong>"); 
                $this.html(new_text); 
             }
              if(text.indexOf("Sculpt & Glow") > -1){ 
                 var new_text = text.replace("Sculpt & Glow","<strong>Sculpt & Glow</strong>"); 
                  $this.html(new_text); 
               }
              if(text.indexOf("One Step Correct") > -1){ 
              var new_text = text.replace("One Step Correct","<strong>One Step Correct</strong>"); 
              $this.html(new_text); 
             }
            }); 
          }
     slideFreeGift();
     }
